"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/table/style/css");

var _table = _interopRequireDefault(require("antd/es/table"));

require("antd/es/tooltip/style/css");

var _tooltip = _interopRequireDefault(require("antd/es/tooltip"));

var _proSolidSvgIcons = require("@fortawesome/pro-solid-svg-icons");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _lodash = require("lodash");

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reselect = require("reselect");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const renderDateWithTime = (value, row) => {
  return (0, _moment.default)(value).format('YYYY-MM-DD HH:SSa');
};

const columns = [{
  title: 'ID',
  dataIndex: 'id',
  key: 'id',
  sorter: (a, b) => a.id - b.id
}, {
  title: 'Label',
  dataIndex: 'label',
  key: 'label',
  sorter: (a, b) => `${a.label}`.localeCompare(b.label),
  render: (value, row) => {
    if (row.label === 'Badge Earned') {
      return /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        title: row.meta.body
      }, row.label, ' ', "(", row.meta.title, ")");
    }

    return row.label;
  }
}, {
  title: 'Create Date',
  dataIndex: 'createDate',
  key: 'createDate',
  render: renderDateWithTime,
  sorter: (a, b) => (0, _moment.default)(a.createDate).unix() - (0, _moment.default)(b.createDate).unix(),
  defaultSortOrder: 'descend'
}, {
  title: 'Results',
  dataIndex: 'result',
  key: 'result',
  render: (value, row) => {
    const spanStyle = {
      marginLeft: '5px'
    };
    const eye = row.viewDate ? _proSolidSvgIcons.faEye : _proSolidSvgIcons.faEyeSlash;

    const viewHover = /*#__PURE__*/_react.default.createElement("span", {
      key: row
    }, row.meta.inAppTitle || row.meta.title, /*#__PURE__*/_react.default.createElement("br", null), row.meta.inAppBody || row.meta.body, /*#__PURE__*/_react.default.createElement("br", null), row.viewDate ? `Viewed ${(0, _moment.default)(row.viewDate).format('YYYY-MM-DD HH:SSa')}` : 'Not Viewed');

    const results = [/*#__PURE__*/_react.default.createElement(_tooltip.default, {
      key: `inApp_${row.id}`,
      title: viewHover
    }, "In-App:", /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: eye
    }))];
    const channels = value.split('\n');

    _lodash._.forEach(channels, channelResult => {
      const parts = channelResult.split(':');
      const icon = _lodash._.endsWith(parts[1], 'Success') ? /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _proSolidSvgIcons.faCheckCircle
      }) : /*#__PURE__*/_react.default.createElement(_tooltip.default, {
        title: parts[1]
      }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _proSolidSvgIcons.faBan
      }));

      if (_lodash._.startsWith(parts[0], 'Popup')) {
        results.push( /*#__PURE__*/_react.default.createElement(_tooltip.default, {
          key: `popup_${row.id}`,
          title: /*#__PURE__*/_react.default.createElement("span", null, row.meta.inAppTitle || row.meta.title, /*#__PURE__*/_react.default.createElement("br", null), row.meta.inAppBody || row.meta.body)
        }, ' ', /*#__PURE__*/_react.default.createElement("span", {
          style: spanStyle
        }, ' ', "PopUp:", icon)));
      } else if (_lodash._.startsWith(parts[0], 'Push')) {
        results.push( /*#__PURE__*/_react.default.createElement(_tooltip.default, {
          key: `push_${row.id}`,
          title: /*#__PURE__*/_react.default.createElement("span", null, row.meta.pushTitle, /*#__PURE__*/_react.default.createElement("br", null), row.meta.pushBodstyey)
        }, ' ', /*#__PURE__*/_react.default.createElement("span", {
          style: spanStyle
        }, ' ', "Push:", icon), ' '));
      } else if (_lodash._.startsWith(parts[0], 'Email')) {
        results.push( /*#__PURE__*/_react.default.createElement(_tooltip.default, {
          key: `email_${row.id}`,
          title: /*#__PURE__*/_react.default.createElement("span", null, row.meta.emailSubject, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", {
            dangerouslySetInnerHTML: {
              __html: row.meta.emailBody
            }
          }))
        }, ' ', /*#__PURE__*/_react.default.createElement("span", {
          style: spanStyle
        }, ' ', "Email:", icon)));
      } else if (_lodash._.startsWith(parts[0], 'SMS')) {
        results.push( /*#__PURE__*/_react.default.createElement(_tooltip.default, {
          key: `sms_${row.id}`,
          title: /*#__PURE__*/_react.default.createElement("span", null, row.meta.smsBody)
        }, ' ', /*#__PURE__*/_react.default.createElement("span", {
          style: spanStyle
        }, ' ', "SMS:", icon)));
      }
    });

    return /*#__PURE__*/_react.default.createElement("span", null, results);
  }
}];

const rowClassName = (record, index) => {
  return index % 2 === 0 ? 'tr-even-color' : 'tr-odd-color';
};

class NotificationLogTable extends _react.PureComponent {
  render() {
    const {
      participantNotifications
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_table.default, {
      columns: columns,
      dataSource: participantNotifications,
      pagination: {
        pageSize: 20
      },
      rowClassName: rowClassName,
      rowKey: "id"
    });
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({});

const mapDispatchToProps = dispatch => {
  return {};
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(NotificationLogTable);

exports.default = _default;